<template>
  <div class="cmp-catalog-products-product_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="search" style="margin-right: -100px">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        />
        <DTCheckbox
          :id="'barcode_catalog_error'"
          :label="'!!!'"
          :checked="basicFilter.barCodeCatalogError"
          @click="onBarcodeCatalogErrorClicked"
          :h="'auto'"
        />
        <Dropdown
          :options="channelFilterTV"
          style="margin-top: -1px; margin-left: 20px; min-width: 150px"
          :placeholder="$t('channels')"
          deselect
          borderbottom
          :selected="
            channelFilterTV.find((e) => e.value == basicFilter.digital_physical)
          "
          v-on:selectedChange="(e) => onDropdownChange('digital_physical', e)"
        />
        <DTIconButton
          :classNames="'search--advanced'"
          :text="$t('products_advanced_search')"
          :style="{
            minWidth: '200px',
            maxWidth: '200px',
          }"
          icon="add-blue"
          @click="onAdvancedSearchClick"
        />
        <div class="search-config--container">
          <div class="search-config">
            <SearchConBadge
              v-for="sconKey of filteredAdvancedSearchConfigKeys"
              :key="sconKey"
              v-bind="searchConfigKey(sconKey)"
              @delete="onSearchConDelete"
            />
          </div>
        </div>
      </div>
      <div class="right-container ut-colcen">
        <div class="ut-flex">
          <button
            class="dt-button v7 s8"
            :class="{
              active:
                searchType == 'product_standard_search' || searchType == 'none',
            }"
            @click="(e) => onFilterButtonClicked('product_standard_search')"
          >
            {{ $t("standard") }}
          </button>
          <button
            class="dt-button v7 s8"
            :class="{
              active: searchType == 'product_weekly_search',
            }"
            @click="(e) => onFilterButtonClicked('product_weekly_search')"
          >
            {{ $t("weekly") }}
          </button>
          <button
            class="dt-button v7 s8"
            :class="{
              active: searchType == 'product_monthly_search',
            }"
            @click="(e) => onFilterButtonClicked('product_monthly_search')"
          >
            {{ $t("monthly") }}
          </button>
          <button class="dt-button v5 s8" @click="onProductExportClicked">
            {{ $t("btn_catalog_report") }}
          </button>
        </div>
      </div>
    </div>
    <div class="dt-page--body" :style="{ '--offset': '120px' }">
      <NTable
        class="h1"
        :headers="headers"
        :config="tableConfig"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onListScroll"
        :id="'catalog-products-product_list'"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            @click="onProductClicked(item)"
            :class="{
              selected: selectedRow(item),
            }"
          >
            <td v-bind="tdcon('costs_catalog_no')">
              <div class="ut-flex">
                <DtStatus
                  :statusTVList="statusTVList"
                  :item="getItemForStatus(item)"
                  @updateStatus="onStatusChange"
                />
                <div
                  class="txtov"
                  :title="item['catalog_no']"
                  style="font-weight: bold; margin-left: 4px"
                >
                  <b> {{ item["catalog_no"] }}</b
                  >&nbsp;
                  <b
                    @click.stop="onCatalogClick(item)"
                    class="ut-text-accent"
                    v-if="item['catalog_error']"
                    >!!!</b
                  >
                </div>
              </div>
              <!-- <span class="txtov" :title="item.catalog_no"
                >{{ item.catalog_no }}
                <b class="ut-text-accent" v-if="item['catalog_error']">!!!</b>
              </span> -->
            </td>
            <td v-bind="tdcon('barcode')">
              <span
                >{{ item["barcode"] }}
                <b
                  @click.stop="onBarcodeClick(item)"
                  class="ut-text-accent"
                  v-if="item['barcode_error']"
                  >!!!</b
                >
              </span>
            </td>
            <td v-bind="tdcon('artist')">
              <span class="txtov" :title="item['release_artist']">
                {{ getAlt(item, "release_artist", "alt_artist") }}</span
              >
            </td>
            <td v-bind="tdcon('product_title')">
              <span class="txtov" :title="item['release_title']">
                {{ getAlt(item, "release_title", "alt_title") }}</span
              >
            </td>

            <td v-bind="tdcon('version')">
              <span class="txtov" :title="item['version']">{{
                item["version"]
              }}</span>
            </td>
            <td v-bind="tdcon('format')" :title="item['format_name']">
              <span class="txtov">{{ item["format_name"] }}</span>
            </td>

            <td v-bind="tdcon('category')" @click.stop="">
              <span> {{ item["category"] }} </span>
              <Dropdown
                :options="product_typesTV"
                :selected="
                  product_typesTV.find(
                    (e) => e.value == item['product_type_id']
                  )
                "
                :style="{
                  'min-height': '28px',
                }"
                :placeholder="$t('category')"
                deselect
                box
                :showExpandedLabel="false"
                v-on:selectedChange="(e) => onProductTypeSelect(item, e)"
              ></Dropdown>
            </td>
            <td v-bind="tdcon('pricecode')">
              <span> {{ item["price_code_name"] }} </span>
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="(e) => onProductDelete(item)"
                class="dt-icon v5 s2 ut-center"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <div class="account-list-footer">
      <DtPageStatusFloat :statusTV="statuses" />
    </div>
    <Sidewindow :value="productDetailsFlag" @closed="onCloseProductDetails">
      <ProductSidewindow :productDetails="productDetails" />
    </Sidewindow>

    <ModalContainer :modalKey="'advancedSearch'" width="556">
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @search="onAdvancedSearch"
        @create_group="onAdvancedSearchCreateGroup"
        @cancelled="onAdvancedSearchCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'productExport'" width="556">
      <ProductExport
        :advancedSearchData="advancedSearchData"
        @export="onAdvancedSearchExport"
        @cancelled="onAdvancedSearchCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'alternateSetup'" width="small">
      <AlternateSetupModal
        @update="onUpdateAlt"
        @cancelled="onAdvancedSearchCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'barcodeAlertModal'" :width="'medium'">
      <BarcodeAlertModal
        @cancelled="onDialogCancelled"
        @changed="onTextFieldValueChange"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'catalogAlertModal'" :width="'medium'">
      <CatalogAlertModal
        @cancelled="onDialogCancelled"
        @changed="onTextFieldValueChange"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'deactiveProduct'" :width="'350'">
      <ProductStatusDeactivateModal @cancelled="onDialogCancelled" />
    </ModalContainer>
  </div>
</template>

<script>
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import InputField from "@plugins/text-field/input-field";
import {
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";

import * as ActionTypes from "../../store/types";
import { CatalogStoreNamespace as storeNS } from "../../store";
import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import ModalContainer from "@dtplugins/modal/modal-container";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import { subscribeSubject, subscribeSubjectND } from "../../../../utility";
import {
  getProductsDetailsSelectable,
  productsListLDTRoutes,
} from "../../router/routes";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { DTIconButton } from "../../../../plugins/button/button";
import { createTV, tv } from "../../../../models/text-value.model";

import { productsCatalogActions } from "../../store/products/actions";
import ProductSidewindow from "./products-sidewindow";
import { productsCatalogGetters } from "../../store/products/getters";
import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";

import AdvancedSearch from "./advanced-search";
import ProductExport from "./product-export";
import BarcodeAlertModal from "./barcode-alert-modal.vue";
import CatalogAlertModal from "./catalog-alert-modal.vue";
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { ProductsService } from "../../services/products.service";
import { LoadedEnd } from "../../../../dt-plugins/advanced-search/load.model";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { createSubmoduleListMixin } from "../../../../dt-plugins/submodule-list/submodule-list.mixin";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";

import DtStatus from "@dtplugins/dt-status-dropdown/dt-status";
import { altWithComma } from "../../../../utility/component.util";

const LDTConfig = {
  entityName: "product",
  ldtRoutes: productsListLDTRoutes,
  detailsSelectableFunction: getProductsDetailsSelectable,
  primaryKey: "product_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.ProductDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.ProductDetails.FETCH.SINGLE,
};

import AlternateSetupModal from "./alternate-setup-modal.vue";

import ProductStatusDeactivateModal from "./product-status-deactivate-modal.vue";

export const productListAdvancedSearchConfig = createAdvancedSearchConfig({
  searchConfigStringKeys: [
    "label_id",
    "artist",
    "title",
    "release_type",
    "release_status",
    "format_id",
    "format_group",
    "channel",
    "genre_id",
    "release_date_from",
    "release_date_to",
    "category_1",
    "category_2",
    "price_list_id",
    "price_code_id",
    "price_from",
    "price_to",
    "payback_from",
    "payback_to",
    "account_id",
    "stock_location_id",
    "stock_from",
    "stock_to",
  ],
  searchConfigTVMap: [
    ["label_id", "labelsTV"],
    ["release_type", "release_typesTV"],
    ["release_status", "release_statusTV"],
    ["format_id", "formatsTV"],
    ["format_group", "format_groupsTV"],
    ["channel", "channelsTV"],
    ["genre_id", "genresTV"],
    ["category_1", "product_typesTV"],
    ["category_2", "product_types2TV"],
    ["price_list_id", "price_listsTV"],
    ["price_code_id", "price_codesTV"],
    ["account_id", "accountsTV"],
    ["stock_location_id", "stock_locationsTV"],
  ],
  booleanSearchKeyLabelMap: {
    barcode_catalog_error: "Barcode Error",
  },
});

export default {
  props: "dropdownProps",
  components: {
    ModalContainer,
    NTable,
    InputField,
    DTIconButton,
    DTCheckbox,
    AlternateSetupModal,
    ProductSidewindow,
    AdvancedSearch,
    ProductExport,
    DtStatus,
    BarcodeAlertModal,
    CatalogAlertModal,
    DtPageStatusFloat,
    ProductStatusDeactivateModal
  },
  mounted: async function () {},
  data: function () {
    return {
      selectedUser: null,
      selectedStatuses: [],
      searchType: "none", // product_standard_search, product_weekly_search, product_monthly_search
      hoverFlag: false,
      hoverPayments: [],
      selectedClickedProduct: null,

      advancedSearchResponse: null,
    };
  },
  mixins: [
    createLDTHost(LDTConfig),
    createModalMixin("advancedSearch"),
    createModalMixin("productExport"),
    createModalMixin("alternateSetup"),
    createModalMixin("barcodeAlertModal"),
    createModalMixin("catalogAlertModal"),

    createFetchListMixin(ActionTypes.ProductList.FETCH.ALL),
    createAdvancedSearchHost(productListAdvancedSearchConfig, {
      onBeforeAdvancedSearchFetch: "onBeforeAdvancedSearchFetch",
    }),
    createSubmoduleListMixin("product"),
    createModalMixin("deactiveProduct"),
  ],
  computed: {
    ...mapGetterObject(storeNS, productsCatalogGetters),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    statuses: function () {
      return createTV(
        this.productList?.label_statuses || [],
        "label_status_name",
        "label_status_colour" || []
      ).map((e) => ({
        text: this.$t(e.text),
        value: e.value,
      }));
    },
    statusTVList: function () {
      return (
        this.productList?.label_statuses?.map((e) => {
          return {
            text: e["label_status_name"],
            value: e["label_status_colour"],
            id: e["label_status_id"],
          };
        }) || []
      );
    },
    list: function () {
      return this.productList?.products || [];
    },

    channelFilterTV: function () {
      return [
        { text: "Digital", value: "digital" },
        { text: "Physical", value: "physical" },
      ];
    },
    product_typesTV: function () {
      return this.productList?.product_types.map(
        tv("product_type_name", "product_type_id")
      );
    },
    headers: function () {
      return [
        createTableHeader("costs_catalog_no", { fw: 700 }),
        createTableHeader("barcode", { f: 0.85 }),
        createTableHeader("artist"),
        createTableHeader("product_title", { text: this.$t('title') }),
        createTableHeader("version", { f: 0.7 }),
        createTableHeader("format", { f: 0.7 }),
        createTableHeader("category", { f: 1.0 }),
        createTableHeader("pricecode", { f: 0.5 }),
        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },
    productDetailsFlag: function () {
      return childOfOrEqualDetails(productsListLDTRoutes, this.$route);
    },

    filter: function () {
      const no_filter_selected = Object.values(this.searchFilter)?.every(
        (e) => !e
      );

      let searchType = this.searchType;
      if (!no_filter_selected && this.searchType == "none") {
        searchType = "product_standard_search";
      }

      return {
        searchType,
        no_filter_selected,

        str: this.basicFilter.searchString,

        start: this.start,
        row_count: this.row_count,

        ...this.searchFilter,
        barCodeCatalogError: this.basicFilter.barCodeCatalogError ? 1 : 0,
        digital_physical: this.basicFilter.digital_physical,
      };
    },

    advancedSearchData: function () {
      return {
        accountsTV: createTV(
          this.advancedSearchResponse?.data?.accounts,
          "account_name",
          "account_id"
        ),
        format_groupsTV: createTV(
          this.advancedSearchResponse?.data?.format_groups
        ),
        formatsTV: createTV(
          this.advancedSearchResponse?.data?.formats,
          "format_name",
          "format_id"
        ),
        channelsTV: [
          {
            text: "Digital",
            value: "digital",
          },
          {
            text: "Physical",
            value: "physical",
          },
        ],
        labelsTV: createTV(
          this.advancedSearchResponse?.data?.labels,
          "label_name",
          "label_id"
        ),
        price_listsTV: createTV(
          this.advancedSearchResponse?.data?.price_lists,
          "price_list_name",
          "price_list_id"
        ),
        price_codesTV: createTV(
          this.advancedSearchResponse?.data?.price_codes,
          "price_code_name",
          "price_code_id"
        ),
        product_typesTV: createTV(
          this.advancedSearchResponse?.data?.product_types.filter(
            (e) => e.valuelist != "2"
          ),
          "product_type_name",
          "product_type_id"
        ),
        product_types2TV: createTV(
          this.advancedSearchResponse?.data?.product_types.filter(
            (e) => e.valuelist == "2"
          ),
          "product_type_name",
          "product_type_id"
        ),
        release_statusTV: createTV(
          this.advancedSearchResponse?.data?.release_status,
          "status",
          "status"
        ),
        release_typesTV: [
          { text: "Album", value: "album" },
          { text: "Single", value: "single" },
          { text: "EP", value: "ep" },
          { text: "Compilation", value: "compilation" },
          { text: "Merchandise", value: "merchandise" },
          { text: "Promo", value: "promo" },
        ],
        genresTV: createTV(
          this.advancedSearchResponse?.genres,
          "genre_name",
          "genre_name"
        ),
        stock_locationsTV: createTV(
          this.advancedSearchResponse?.stock_locations,
          "stock_location_name",
          "stock_location_id"
        ),
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, productsCatalogActions),
    getAlt: altWithComma,
    fetchData: function () {},
    getItemForStatus: function (item) {
      return {
        itemID: item.product_id,
        colorPropertyName: "label_status_id",
        colorPropertyValue: item.label_status_id,
        colorName: "label_status_colour",
        colorValue: item.label_status_colour,
      };
    },
    defaultBasicFilter() {
      return {
        searchString: "",
        barCodeCatalogError: false,
        digital_physical: "",
      };
    },
    onDropdownChange: function (name, value) {
      // <-- Normal Form Handling Methods
      this.basicFilter[name] = value.value;
      //this.resetSearchFilter();

      this.fetchListReset();
    },
    onProductTypeSelect: function (product, value) {
      this[ActionTypes.ProductList.UPDATE.SINGLE]({
        name: "product_type_id",
        item: product,
        value: value.value,
      });
    },

    refresh: function () {
      this.fetchListNext();
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onTextFieldValueChange: async function (event) {
      console.log("eventevent", event);
      const { name, value, kVal } = event;
      await ProductsService.modify({
        name,
        value,
        kVal,
      });
      this.fetchListReset();
    },
    onCatalogClick: async function (product) {
      this.selectedClickedProduct = product;
      this.$router.push({
        ...this.$route,
        query: {
          modal: "catalog_alert_modal",
          product_id: product.product_id,
        },
      });
    },
    onBarcodeClick: async function (product) {
      this.selectedClickedProduct = product;
      this.$router.push({
        ...this.$route,
        query: {
          modal: "barcode_alert_modal",
          product_id: product.product_id,
        },
      });
    },
    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },

    // NEW

    onProductClicked: function (product) {
      if (this.loadingFlag) {
        return;
      }
      this.selectedClickedProduct = product;
      this.$router.push({
        name: productsListLDTRoutes.names.tab,
        params: {
          product_id: product.product_id,
          tab: "overview",
        },
      });
    },
    onProductDelete: async function (item) {
      const res = await ProductsService.productRelationInfo(item.product_id);

      const info = res.data.info;

      // ConfirmationService

      if (info.related == 1) {
        const confirmationResult = await ConfirmationService.createP({
          body: this.$t("product_relation"),
          width: 376,
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        });
      } else if (info.related == 0) {
        // const confirmationResult = await ConfirmationService.createP({
        //   body: "Do you really want to delete this Product?",
        //   results: [
        //     createConfirmResult({
        //       value: "no",
        //       text: "No",
        //     }),
        //     createConfirmResult({
        //       value: "yes",
        //       text: "Yes",
        //       classes: ["v1"],
        //     }),
        //   ],
        // });

        // if (confirmationResult === "yes") {
        //   this[ActionTypes.ProductList.DELETE.SINGLE](item);
        // }

        const confirmationResult = await confirmDelete(
          "Product",
          item.release_artist
        );
        if (confirmationResult === "OK") {
          this[ActionTypes.ProductList.DELETE.SINGLE](item);
        }
      }

      console.log(info);
    },
    onCloseProductDetails: function () {
      console.log("onCloseProductDetails");
      this.selectedClickedProduct = null;
      this.refresh();
      handleFromRoute(this, () => {
        this.$router.push({
          name: productsListLDTRoutes.names.list,
        });
      });
    },
    onProductExportClicked: function () {
      openModalRoute(this, "product_export");
    },
    onFilterButtonClicked: function (searchType) {
      this.searchType = searchType;
      this.fetchListReset();
    },
    onAdvancedSearchExport: function () {},
    onAdvancedSearchCreateGroup: function () {},
    // onAdvancedSearchCancelled: function () {
    //   closeModalRoute(this);
    // },
    fetchAdvancedSearchData: async function () {
      const advancedSearchData =
        await ProductsService.fetchAdvancedSearchData();
      this.advancedSearchResponse = advancedSearchData.data;
      console.log(
        "this.advancedSearchResponse",
        this.advancedSearchResponse,
        "this.advancedSearchResponse"
      );
    },
    onBarcodeCatalogErrorClicked: function (event) {
      this.basicFilter.barCodeCatalogError = event.target.checked;
      this.searchType = "none";
      this.resetSearchFilter();
      this.fetchListReset();
    },
    onBeforeAdvancedSearchFetch: function () {
      this.resetBasicFilter();
    },

    onUpdateAlt: async function (payload) {
      console.log(payload);
      this.onAdvancedSearchCancelled();
      await ProductsService.updateProductAltArtistTitle({ ...payload });

      this[ActionTypes.ProductDetails.FETCH.SINGLE]({
        product: payload,
        reload: true,
      });
    },
    onStatusChange: function (payload) {
      //const item = this.selectedReleaseDetails;
      const {
        itemID,
        colorPropertyName,
        colorPropertyValue,
        colorValue,
        colorName,
      } = payload;
      const item = this.productList?.products.find(
        (x) => x.product_id == itemID
      );

      const statusArray =  this.productList?.label_statuses;

      const inactive_flag = statusArray.find(x=>x.label_status_id == colorPropertyValue ).inactive_flag;

      if(inactive_flag && (inactive_flag==1 || inactive_flag=='1')){
        this.$router.push({
          ...this.$route,
          query: {
            modal: "deactive_product",
            primary_key:item.product_id,
            name:`${item.catalog_no}-${item.barcode}`,
            status_id:colorPropertyValue,
            mode:'deactivate'

          }
        });
      }else{
        this.$router.push({
          ...this.$route,
          query: {
            modal: "deactive_product",
            primary_key:item.product_id,
            name:`${item.catalog_no}-${item.barcode}`,
            status_id:colorPropertyValue,
            mode:'activate'

          }
        });
      }



      this[ActionTypes.ProductList.UPDATE.SINGLE]({
        item,
        name: colorName,
        value: colorValue,
        colorPropertyName,
        colorPropertyValue,
      });
      console.log(item, "payload");
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-product_list {
  .dt-page--top-bar {
    .search {
      .dt-checkbox-control {
        .dt-checkbox-label {
          color: var(--text-accent);
          font-weight: 500;
        }
      }
    }
  }
}
</style>
